import { DeleteTwoTone, DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table } from 'ant-table-extensions';
import { Collapse, Divider, Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment, { Moment } from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { searchCustomerMSB } from '../../api/NetworkingCustomers';
import { deleteTransactionUpload, searchTransactionUpload } from '../../api/NetworkingTransactionUpload';
import AppContext from '../../App.context';
import { getResource } from '../../helpers/ResourcesHelper';
import Button from '../inputs/Button';
import DatePicker from '../inputs/DatePicker';
import { UploadTransactionFile } from '../models/UploadTransactionFile';

const { Panel } = Collapse;

const UploadFileTable = (props: any) => {
  const { showModal, showLoadingModal, hideLoadingModal } = useContext(AppContext);
  const [transactions, setTransactions] = useState<UploadTransactionFile[]>([]);
  const [updating, setUpdating] = useState<boolean>(false);
  const [transactionDate, setTransactionDate] = useState<string>('');
  const [momentTransactionDate, setMomentTransactionDate] = useState<Moment>();
  const [fromDate, setFromDate] = useState<string>('');
  const [momentFromDate, setMomentFromDate] = useState<Moment>();
  const [toDate, setToDate] = useState<string>('');
  const [momentToDate, setMomentToDate] = useState<Moment>();
  const [msb, setMsb] = useState<string>('');
  const [msbId, setMsbId] = useState<number>(0);
  const [transactionID, setTransactionID] = useState('');
  const [msbs, setMsbs] = useState([{ label: '', value: '' }]);
  const [uploadTransactionsTemplate, setUploadTransactionsTemplate] = useState([]);

  useEffect(() => {
    let tempMsb = 0;
    if (msbId !== 0) tempMsb = msbId;
    let tempDate = null;
    if (transactionDate !== '') tempDate = transactionDate;
    let tempFromDate = null;
    if (fromDate !== '') tempFromDate = fromDate;
    let tempToDate = null;
    if (toDate !== '') tempToDate = toDate;

    let dateRangeValid = true;
    if (fromDate !== '' && toDate !== '') {
      if (fromDate > toDate) dateRangeValid = false;
    }

    if (dateRangeValid) {
      let userSession = JSON.parse(localStorage.getItem('UserSession')!);
      searchTransactionUpload(userSession.CustomerID, tempFromDate, tempToDate).then((response) => {
        if (response != null && response.TransactionUpload != null) {
          response.TransactionUpload.forEach((transaction: any) => {
            transaction.key = transaction.Id;
          });
          setTransactions(response.TransactionUpload);
        } else {
          setTransactions([])
        }
      });
    } else {
      showModal(getResource('Title.Warning'), getResource('DateGreaterThanOrEqualToFromDate'));
    }
    /*if (!updating) {
      getCustomerMSB().then((response) => {
        if (response != null && response.msbs != null) {
          setMsbs(response.msbs);
        } else {
          setMsbs([])
        }
      })
    }*/
  }, [updating]);

  useEffect(() => {
    let today = new Date();
    let yearString = today.getFullYear().toString();
    let monthString = (today.getMonth() + 1).toString().padStart(2, '0');
    let dayString = today.getDate().toString().padStart(2, '0');
    let hourString = today.getHours().toString().padStart(2, '0');
    let minuteString = today.getMinutes().toString().padStart(2, '0');
    let timeStamp = yearString + monthString + dayString + hourString + minuteString;

    let newFileName = 'TransactionsTemplate' + timeStamp + ".xlsx";
    //setFileName(newFileName);
    //setUploadTransactionsTemplate(data);
  }, [])

  useEffect(() => {
    if (props.reload) {
      let tempMsb = 0;
      if (msbId !== 0) tempMsb = msbId;
      let tempDate = null;
      if (transactionDate !== '') tempDate = transactionDate;
      let tempFromDate = null;
      if (fromDate !== '') tempFromDate = fromDate;
      let tempToDate = null;
      if (toDate !== '') tempToDate = toDate;

      let dateRangeValid = true;
      if (fromDate !== '' && toDate !== '') {
        if (fromDate > toDate) dateRangeValid = false;
      }

      if (dateRangeValid) {
        let userSession = JSON.parse(localStorage.getItem('UserSession')!);
        searchTransactionUpload(userSession.CustomerID, tempFromDate, tempToDate).then((response) => {
          if (response != null && response.TransactionUpload != null) {
            response.TransactionUpload.forEach((transaction: any) => {
              transaction.key = transaction.Id;
            });
            setTransactions(response.TransactionUpload);
          } else {
            setTransactions([])
          }
        });
      } else {
        showModal(getResource('Title.Warning'), getResource('DateGreaterThanOrEqualToFromDate'));
      }
    }
  }, [props.reload])

  const columns: ColumnsType<UploadTransactionFile> = [
    {
      title: getResource('Table_TH_TransactionDate'),
      dataIndex: 'Date',
      key: 'transaction_valuedate',
      align: 'center',
      sorter: (a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime()
      //sorter: (a, b) => a.Date.localeCompare(b.MSB)
    },
    {
      title: getResource('Table_TH_MSB'),
      dataIndex: 'MSB',
      key: 'transaction_msb',
      align: 'center',
      sorter: (a, b) => a.MSB.localeCompare(b.MSB)
    },
    {
      title: getResource('Table_TH_Status'),
      dataIndex: 'Status',
      key: 'transaction_status',
      align: 'center',
      sorter: (a, b) => a.Status.localeCompare(b.Status)
    },
    {
      title: getResource('Table_TH_FileName'),
      dataIndex: 'FileName',
      key: 'transaction_filename',
      align: 'center',
      sorter: (a, b) => a.FileName.localeCompare(b.FileName)
    },
    {
      title: getResource('Table_TH_RecordsNumber'),
      dataIndex: 'RecordsNumber',
      key: 'transaction_recordsnumber',
      align: 'center',
      sorter: (a, b) => a.RecordsNumber.localeCompare(b.RecordsNumber)
    },
    {
      title: getResource('Table_TH_TotalAmount'),
      dataIndex: 'TotalAmount',
      key: 'transaction_totalamount',
      align: 'center',
      sorter: (a, b) => a.TotalAmount.localeCompare(b.TotalAmount)
    },
    {
      title: getResource('Table_TH_Actions'),
      dataIndex: 'actions',
      key: 'actions',
      align: 'left',
      render: (value: any, obj: any, index: any) => (
        <>
          <Tooltip title={getResource('Label.Refresh')}>
            <Typography.Link
              onClick={() => {
                selectRow(obj);
              }}
            >
              <ReloadOutlined />
            </Typography.Link>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title={getResource('Delete')}>
            <Typography.Link
              onClick={
                async () => {
                  if (obj.Status === 'Pending') {
                    showLoadingModal();
                    await deleteTransactionUpload(obj.Id).then((value) => {
                      const httpStatusCode = value.httpStatusCode;
                      switch (httpStatusCode) {
                        case 200:
                          setUpdating(true);
                          showModal(getResource('Js_MessageError_TitleSuccess'), getResource('Js_Message_DeleteSuccessfully'));
                          break;
                        case 500:
                        case 503:
                          showModal(getResource('Js_MessageError_TitleError'), getResource('InternalServerError') + value.Message);
                          break;
                      }
                      hideLoadingModal();
                    });
                  } else {
                    showModal(getResource('Title.Warning'), getResource('Js_Message_WarningPendingRecords'));
                  }
                }}
            >
              <DeleteTwoTone />
            </Typography.Link>
          </Tooltip>
        </>
      )
    }
  ];

  const selectRow = (record: any) => {
    props.selectRow(record.Id);
  };

  const onResetFilters = () => {
    setTransactionID('');
    //setTransactionDate('');
    setFromDate('');
    setToDate('');
    //setMomentTransactionDate(moment());
    setMomentFromDate(moment());
    setMomentToDate(moment());
    setMsb('');
    setMsbId(0);
    setUpdating(!updating);
  };

  const onChangeTransactionDate = (date: Moment | null, dateString: string) => {
    setTransactionDate(dateString);
    setMomentTransactionDate(date as Moment);
  };

  const onChangeFromDate = (date: Moment | null, dateString: string) => {
    setFromDate(dateString);
    setMomentFromDate(date as Moment);
  };

  const onChangeToDate = (date: Moment | null, dateString: string) => {
    setToDate(dateString);
    setMomentToDate(date as Moment);
  };

  const msbChangeHandler = (item: any, option: any) => {
    if (option != null && !option.label.includes('Select')) {
      setMsbId(option.value);
      setMsb(option.label);
    }
  }

  const onSearch = (value: any) => {
    setMsb(value);
    searchCustomerMSB(value).then(
      (json) => {
        if (json.customers != null) {
          setMsbs(json.customers);
        }
      }
    )
  }

  const onChange = (data: string, option: any) => {
    setMsb(data);
  };

  return (
    <React.Fragment>
      <Collapse defaultActiveKey={['1']} style={{ marginBottom: '15px' }}>
        <Panel header={getResource('Title.FilterOptions')} key="1" >
          <div className="row center-md">
            <div className="row">
              {/*<div className="col-md-6 col-xs-12">
                <div className="row">
                  <span className="input-label">MSB:</span>
                </div>
                <div className="row">
                  <AutoComplete
                    allowClear
                    options={msbs}
                    placeholder={getResource('SelectMSB')}
                    notFoundContent={getResource('PlaceHolder.NoResults')}
                    value={msb}
                    onSelect={msbChangeHandler}
                    onSearch={onSearch}
                  />
                </div>
  </div>*/}
              <div className="col-md-4 col-xs-12">
                <div className="row">
                  <span className="input-label">{getResource('DateFrom')}:</span>
                </div>
                <div className="row">
                  <DatePicker
                    id="uploadfile-datepicker-fromdate"
                    key="uploadfile-datepicker-fromdate"
                    onChange={onChangeFromDate}
                    value={momentFromDate}
                    submit={true}
                  />
                </div>
              </div>
              <div className="col-md-4 col-xs-12">
                <div className="row">
                  <span className="input-label">{getResource('DateTo')}:</span>
                </div>
                <div className="row">
                  <DatePicker
                    id="uploadfile-datepicker-todate"
                    key="uploadfile-datepicker-todate"
                    onChange={onChangeToDate}
                    value={momentToDate}
                    submit={true}
                  />
                </div>
              </div>
              <div className="col-md-5 col-xs-12" style={{ paddingTop: 30 }}>
                <Button type="secondary" onClick={() => setUpdating(!updating)}>
                  {getResource('ApplyFilter')}
                </Button>
              </div>
              <div className="col-md-3 col-xs-12" style={{ paddingTop: 30 }}>
                <Button type="primary" onClick={onResetFilters}>
                  {getResource('Reset')}
                </Button>
              </div>
              {/*<div className="col-md-5 col-xs-12" style={{ paddingTop: 30 }}>
                <ExcelDownloder
                  data={data}
                  filename={fileName}
                  type={Type.Link}>
                  {getResource('SubMenu_DownloadTemplateForOrders')}
                </ExcelDownloder>
              </div>*/}
            </div>
          </div>
        </Panel>
      </Collapse>
      <Table
        className=""
        key={'upload-transactions-table'}
        columns={columns}
        dataSource={transactions}
        exportableProps={{
          fileName: 'Transactions',
          btnProps: {
            type: "default",
            icon: <DownloadOutlined />,
          }
        }}
      />
    </React.Fragment>
  );
};

export default UploadFileTable;